<template>
  <div>
    <v-menu
      v-model="isOpen"
      :close-on-content-click="false"
      height="510px"
      width="380px">
      <template #activator="{ props }">
        <v-btn
          border
          density="comfortable"
          icon
          rounded="lg"
          size="small"
          v-bind="props">
          <v-badge
            :content="notificationUnreadCountLabel"
            :model-value="!!notificationUnreadCount"
            bordered
            color="error"
            location="top right">
            <v-icon icon="mdi-bell-outline"></v-icon>
          </v-badge>
        </v-btn>
      </template>

      <notification-list @read-all="isOpen = false"></notification-list>
    </v-menu>
  </div>
</template>

<script lang="ts">
import NotificationList from './NotificationList.vue'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { socket, notificationChannel } from '@/socket'
import { useNotificationList } from './notificationList'
import type { Notification } from '@/utils/types/notification'

export default {
  name: 'Notifications',
  components: { NotificationList },
  setup() {
    const store = useStore()
    const isOpen = ref(false)
    const { getNotificationUnreadCount, unreadCount, addIncomingNotification } =
      useNotificationList()
    const notificationUnreadCount = ref<number>(unreadCount.value)
    const notificationUnreadCountLabel = computed(() =>
      notificationUnreadCount.value > 99 ? '99+' : notificationUnreadCount.value
    )

    const handleIncoming = (item: Notification): void => {
      if (!item || item.userId !== store.state.user.userData?.id) {
        return
      }

      addIncomingNotification(item)
      notificationUnreadCount.value = unreadCount.value
    }

    onMounted(async () => {
      notificationUnreadCount.value = await getNotificationUnreadCount()
      socket.on(notificationChannel, handleIncoming)
    })

    onUnmounted(() => {
      socket.off(notificationChannel, handleIncoming)
    })

    watch(isOpen, v => {
      if (!v) {
        notificationUnreadCount.value = unreadCount.value
      }
    })

    return { notificationUnreadCount, notificationUnreadCountLabel, isOpen }
  },
}
</script>
